import { useEffect, useState, type FormEvent } from "react";
import { useParams } from "react-router-dom";
import { api, type TaskRow } from "../api.ts";
import { fmtDate } from "../lib/format.ts";

const FRONTS = ["seo", "conversao", "midia", "recompra", "catalogo", "financeiro"];
const PHASES = ["fase_0", "fase_1", "fase_2", "fase_3"];

export function TasksPage() {
  const { slug } = useParams<{ slug: string }>();
  const [tasks, setTasks] = useState<TaskRow[]>([]);
  const [showDone, setShowDone] = useState(false);
  const [form, setForm] = useState<any>({ title: "", front: "", phase: "", owner: "", due_date: "" });

  const load = async () => {
    const d = await api.get<{ tasks: TaskRow[] }>(`/api/t/${slug}/tasks${showDone ? "" : "?status=pending"}`);
    setTasks(d.tasks);
  };
  useEffect(() => { load(); }, [slug, showDone]);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!form.title) return;
    await api.post(`/api/t/${slug}/tasks`, {
      ...form,
      front: form.front || null,
      phase: form.phase || null,
      due_date: form.due_date || null,
    });
    setForm({ title: "", front: "", phase: "", owner: "", due_date: "" });
    load();
  };

  const toggleDone = async (t: TaskRow) => {
    await api.patch(`/api/t/${slug}/tasks/${t.id}`, {
      status: t.status === "done" ? "pending" : "done",
    });
    load();
  };

  return (
    <>
      <div className="section-head">
        <div>
          <p className="eyebrow">Plano</p>
          <h1>Tarefas</h1>
        </div>
        <label style={{ fontSize: ".88rem", display: "inline-flex", alignItems: "center", gap: ".4rem" }}>
          <input type="checkbox" checked={showDone} onChange={(e) => setShowDone(e.target.checked)} />
          mostrar concluídas
        </label>
      </div>

      <div className="card" style={{ marginBottom: "1.5rem" }}>
        <h3>Nova tarefa</h3>
        <form className="form" style={{ maxWidth: "100%" }} onSubmit={onSubmit}>
          <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr auto", gap: ".6rem" }}>
            <input placeholder="Título" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} required />
            <select value={form.front} onChange={(e) => setForm({ ...form, front: e.target.value })}>
              <option value="">— frente —</option>
              {FRONTS.map((f) => <option key={f} value={f}>{f}</option>)}
            </select>
            <select value={form.phase} onChange={(e) => setForm({ ...form, phase: e.target.value })}>
              <option value="">— fase —</option>
              {PHASES.map((p) => <option key={p} value={p}>{p}</option>)}
            </select>
            <input placeholder="Responsável" value={form.owner} onChange={(e) => setForm({ ...form, owner: e.target.value })} />
            <input type="date" value={form.due_date} onChange={(e) => setForm({ ...form, due_date: e.target.value })} />
            <button className="btn" type="submit">Criar</button>
          </div>
        </form>
      </div>

      <div className="card">
        {tasks.length === 0 ? (
          <p style={{ color: "var(--text-muted)" }}>nenhuma tarefa.</p>
        ) : tasks.map((t) => (
          <div key={t.id} className="list-row" style={{ alignItems: "center" }}>
            <span style={{ flex: 1 }}>
              <input
                type="checkbox"
                checked={t.status === "done"}
                onChange={() => toggleDone(t)}
                style={{ marginRight: ".6rem" }}
              />
              <strong style={{ textDecoration: t.status === "done" ? "line-through" : "none", opacity: t.status === "done" ? .6 : 1 }}>
                {t.title}
              </strong>
              {t.front && <span className="pill" style={{ marginLeft: ".5rem" }}>{t.front}</span>}
              {t.owner && <span className="mono" style={{ fontSize: ".78rem", marginLeft: ".5rem", opacity: .55 }}>{t.owner}</span>}
            </span>
            <span className="mono" style={{ fontSize: ".78rem", opacity: .6 }}>{fmtDate(t.due_date)}</span>
          </div>
        ))}
      </div>
    </>
  );
}
